import Screen from "@/src/components/Screen/Screen";
import useUrlState from "@/src/hooks/use-url-state";
import { Modal } from "@/src/components/Modal/Modal";
import AddPayments from "./components/AddPayments";
import { useUserPaymentMethods } from "@/src/hooks/usePaymentMethods";
import { Plus } from "lucide-react";
import AvailablePayments from "./components/AvailablePayments";
import { Button } from "@/src/components/Button/Button";
// import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";
import { useTranslation } from "react-i18next";
// import { Affix } from "@mantine/core";
// import { useMediaQuery } from "usehooks-ts";

const PaymentMethods = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.paymentMethods.${key}`);
  const [addPayment, setAddPayment] = useUrlState("add_payment");
  const { paymentMethods, isLoading, isFetching } = useUserPaymentMethods();
  // const [type, setType] = useUrlState('type', 'buy')
  // const isSmallDevice = useMediaQuery("(max-width: 768px)");

  return (
    <div>
      <Screen loading={isLoading || isFetching}>
        <div className="flex justify-between items-center w-full md:p-4 p-2">
          <div>
            <h2 className={textVariants({ size: "xl", font: "bold" })}>
              {trans("header")}
            </h2>
          </div>
          <div>
            <Button
              onClick={() => setAddPayment("open")}
              className="md:flex hidden items-center gap-2"
            >
              <Plus className="h-4 w-4" /> {trans("addButton")}
            </Button>
            <Button
              onClick={() => setAddPayment("open")}
              className="md:hidden flex items-center gap-2"
            >
              <Plus className="h-4 w-4" /> {trans("add")}
            </Button>
          </div>
        </div>
        <div className="px-4 "></div>
        <AvailablePayments pm={paymentMethods} />
        <Modal
          title={t("app.components.modalTitles.addPaymentMethod")}
          open={addPayment === "open"}
          size={"md"}
          setOpen={(val) => setAddPayment(val ? undefined : "open")}
        >
          <AddPayments />
        </Modal>
      </Screen>
    </div>
  );
};

export default PaymentMethods;
